import { authUsuarioComputed } from "@/state/helpers";
import { mapActions, mapGetters } from "vuex";
import config from "@/config";
export default {
    computed: {
        ...authUsuarioComputed,
        ...mapGetters({
            userRestrictedDocuments: "document/userRestrictedDocuments",
        }),
        userAuthIsInListUserRestrictedDocuments(){
            return this.userRestrictedDocuments.items.find(item => item.email === this.user.email) != null
        },
    },
    methods: {
        ...mapActions({
            getUserRestrictedDocuments: "document/getUserRestrictedDocuments",
        }),
        async getUserRestrictedDocumentsData(user){
            if(!this.userRestrictedDocuments.items.length){
                let self = this;
                await self.getUserRestrictedDocuments({
                    password: config.password_manteiners,
                    page: 0,
                    filter: user,
                    document_viewer: true
                });
            }
        },
    },
    watch: {
        "user": {
            immediate: true,
            handler(user){
                if(user){
                    this.getUserRestrictedDocumentsData(user.email)
                }
            }
        } 
    }
}